require('./bootstrap');

require('alpinejs');

require('./ckeditor');

import Inputmask from "inputmask";
window.inputmask = require('inputmask');
